var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.726 12.9541C14.3065 12.9541 13.1565 14.0986 13.1565 15.4967C13.1565 16.8949 14.3131 18.0394 15.726 18.0394C17.1389 18.0394 18.2955 16.8949 18.2955 15.4967C18.2955 14.0986 17.1389 12.9541 15.726 12.9541Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9132 8.94819H12.4073C10.5541 8.94819 9.0426 10.4439 9.0426 12.2777V18.7158C9.0426 20.5496 10.5541 22.0453 12.4073 22.0453H18.9132C20.7664 22.0453 22.2779 20.5496 22.2779 18.7158V12.2777C22.2779 10.4439 20.7664 8.94819 18.9132 8.94819ZM15.726 19.4701C13.5113 19.4701 11.7107 17.6883 11.7107 15.4967C11.7107 13.3052 13.5113 11.5234 15.726 11.5234C17.9406 11.5234 19.7413 13.3052 19.7413 15.4967C19.7413 17.6883 17.9406 19.4701 15.726 19.4701ZM19.9778 12.2062C19.4521 12.2062 19.0249 11.7835 19.0249 11.2633C19.0249 10.743 19.4521 10.3203 19.9778 10.3203C20.5036 10.3203 20.9307 10.743 20.9307 11.2633C20.9307 11.7835 20.5036 12.2062 19.9778 12.2062Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6603 0C7.01196 0 0 6.93875 0 15.4967C0 24.0548 7.01196 30.9935 15.6603 30.9935C24.3086 30.9935 31.3205 24.0548 31.3205 15.4967C31.3205 6.93875 24.3086 0 15.6603 0ZM23.8091 18.7158C23.8091 21.3885 21.6142 23.5605 18.9132 23.5605H12.4073C9.70634 23.5605 7.5114 21.3885 7.5114 18.7158V12.2777C7.5114 9.60499 9.70634 7.43298 12.4073 7.43298H18.9132C21.6142 7.43298 23.8091 9.60499 23.8091 12.2777V18.7158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1ef44a88df281983c6713b033f7edbe0.svg";
export { ForwardRef as ReactComponent };